<template>
  <div class="log">
    <header class="head">
      <a class="logo-wrapper" href="/">
        <img src="./logo.jpg" alt="logo" width="180" height="40">
      </a>
      <section class="service-wrapper">
        <p class="text">客服电话：</p>
        <p class="number">0571-28815085</p>
      </section>
    </header>
    <div class="content">
      <div class="back-wrapper"></div>
      <div class="content-layout">
        <div class="log-wrapper">
          <div class="tab">
            <span class="tab-item"
                  :class="{'active':tabindex===1}"
                  @click="tabindex=1">账号密码登录
            </span>
            <span class="tab-item"
                  @click="tabindex=2"
                  :class="{'active':tabindex===2}">手机快速登录
            </span>
          </div>
          <div class="log-mid-wrapper" v-if="tabindex===1">
            <p class="row">
              <input class="input-phone"
                     ref="phonePassword"
                     type="text"
                     maxlength="11"
                     placeholder="请输入手机号码"
                     :value="integer"
                     @keyup="integerChange">
            </p>
            <p class="row">
              <input class="input-phone"
                     type="password"
                     placeholder="请输入登录密码"
                     v-model="password"
                     @keyup.enter="loginByPassword">
            </p>
            <button class="log-btn" @click="loginByPassword">确定登录</button>
          </div>
          <div class="log-mid-wrapper" v-if="tabindex===2">
            <p class="row">
              <input class="input-phone"
                     type="text"
                     ref="phonePassword"
                     maxlength="11"
                     placeholder="请输入手机号码"
                     :value="integer"
                     @keyup="integerChange">
            </p>
            <p class="row">
              <input class="input-phone"
                     type="text"
                     ref="code"
                     placeholder="请输入验证码"
                     @keyup.enter="loginByMobile"
                     v-model="code">
              <span class="send" @click="send" v-if="!whetherSend">获取验证码</span>
              <span class="time" v-if="whetherSend">{{time + 's'}}</span>
            </p>
            <button class="log-btn" @click="loginByMobile">确定登录</button>
          </div>
          <p class="hint">还没有注册？
            <router-link to="/register">快速注册</router-link>
          </p>
        </div>
      </div>
    </div>
    <foot-nav></foot-nav>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal, saveSession, loadSession} from 'common/js/store.js';
  import md5 from 'js-md5'
  import footNav from 'components/footnav/FootNav'
  export default{
    data(){
      return {
        id: '',
        tabindex: 1,     //1是密码登录，2是验证码登录
        inputInteger: '',
        code: '',          //用户输入的验证码
        whetherSend: false,      //表示是否点击了发送验证码
        time: 60, // 发送验证码倒计时
        password: '',          //用户输入的验证码
        url: '',
      }
    },
    methods: {
      integerChange(e) {
        this.inputInteger = e.target.value;
        this.$forceUpdate()  // 这里必须有
      },
      send(){
        let phoneNumber=this.integer||this.$refs.phonePassword.value;
        if (phoneNumber.length !== 11) {
          this.$message({
            message: '请输入正确的手机号码!',
            type: 'warning'
          });
          return;
        }
        this.whetherSend = true;
        let _this = this;
        let interval = window.setInterval(function () {
          if ((_this.time--) <= 0) {
            _this.time = 60;
            _this.whetherSend = false;
            window.clearInterval(interval);
          }
        }, 1000);
        //接口：发送手机验证码
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'sendMessage',
            a: 'sendSms',
            mobile: phoneNumber,
            type: 0
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.$message({
              message: '发送成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
        })

      },
      loginByMobile(){
        let phoneNumber=this.integer||this.$refs.phonePassword.value;
        let inputCode=this.code||this.$refs.code.value;
        if (inputCode == '') {
          this.$message({
            message: '请输入验证码',
            type: 'warning'
          });
          return;
        }
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'User',
            a: 'loginByMobile',
            mobile: phoneNumber,
            code: inputCode
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            //如果用户没有设置密码
            //如果用户是老师，需要查询该老师是否有网校
            if (response.identity === 1) {
              this.id = response.id;
              saveLocal('id', response.id);
              saveLocal('userinfo', response);
              this.QueryManagerRooms();
            } else {
              //如果用户没有密码，证明用户为从首页弹出框注册，没有设置密码
              if (response.password == 0) {
                saveSession('tempid', response.id)
                this.$router.push('/fillstudent');
                return;
              }
              //则需要根据相应路径进行跳转
              saveLocal('id', response.id);
              saveLocal('userinfo', response);
              window.location.href='/';
//              window.history.back();
//              if (this.url.indexOf('study') === -1) {
//                this.$router.replace(this.url)
//              } else {
//                window.location.replace(this.url);
//              }
            }
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
        })
      },
      loginByPassword(){
        let phoneNumber=this.integer||this.$refs.phonePassword.value;
        if (phoneNumber.length !== 11) {
          this.$message({
            message: '请输入正确的手机号码!',
            type: 'warning'
          });
          return;
        }
        if (this.password === '') {
          this.$message({
            message: '请输入密码',
            type: 'warning'
          });
          return;
        }
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'User',
            a: 'loginmobile',
            mobile: phoneNumber,
            password: md5(this.password).toLowerCase()
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            //如果用户是老师，需要查询该老师是否有网校
            if (response.identity === 1) {
              this.id = response.id;
              saveLocal('id', response.id);
              saveLocal('userinfo', response);
              this.QueryManagerRooms();
            } else {
              //则需要根据相应路径进行跳转
              saveLocal('id', response.id);
              saveLocal('userinfo', response);
              window.location.href='/';
//              window.history.back();
//              if (this.url.indexOf('student') === -1) {
//                this.$router.replace(this.url)
//              } else {
//                window.location.replace(this.url);
//              }
            }
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
        })
      },
      QueryManagerRooms(){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Room',
            a: 'QueryManagerRooms',
            id: this.id
          }
        }).then((response) => {
          response = response.data;
          //code返回101时表示没有网校
          if (response.code === 101) {
            //如果没有网校，说明该用户注册老师时，只是完成了第一步，并没有填写教师资料，因此没有创建网校
            this.$router.replace('/fillin');
          }
          if (response.code === 200) {
            window.location.href='/';
//            window.history.back();
//            if (this.url.indexOf('student') === -1) {
//              this.$router.replace(this.url)
//            } else {
//              window.location.replace(this.url);
//            }
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      }
    },
    computed: {
      integer() {
        let tempVaule=this.inputInteger;
        if(this.$refs.phonePassword){
          tempVaule=tempVaule||this.$refs.phonePassword.value;
        }

        return tempVaule.replace(/[^\d]/g, '').replace(/^0/g, "");
      },
    },
    created(){
      //如果用户直接登录，则默认是'/account'
      let url = decodeURIComponent(this.$utils.getUrlKey('url'));
      url = (url === 'null') ? '/account' : url;
      this.url = url;
    },
    components: {
      footNav
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .log
    height: 100%
    background: #ffffff
    .head
      width: 1226px
      height: 80px
      margin: 0 auto
      background: #fff
      font-size: 0
      .logo-wrapper
        float: left;
        height: 43px;
        width: 192px;
        padding-top: 18px;
      .service-wrapper
        float: right
        width: 140px;
        padding-top: 18px
        .text
          height: 20px
          line-height: 20px
          font-size: 14px
          color: #333;
        .number
          height: 25px
          line-height: 25px
          font-size: 18px
          color: #333;
    .content
      min-height: calc(100vh - 425px);
      padding-bottom: 90px;
      font-size: 0;
      position: relative;
      box-sizing: border-box
      .back-wrapper
        position: absolute;
        z-index: 9;
        top: 0;
        left: 0;
        height: 710px
        width: 100%;
        background-image: url('./back.jpg')
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center
      .content-layout
        width: 1226px
        margin: 0 auto
        overflow: hidden;
        position: relative;
        height: 710px;
        z-index: 999;
        .log-wrapper
          position: absolute;
          top: 128px;
          right: 0;
          width: 400px
          height: 450px;
          padding: 40px 37px 0
          background: #fff
          box-sizing: border-box
          border-radius: 4px
          overflow: hidden
          .tab
            height: 25px;
            padding-bottom: 16px;
            border-bottom: 1px solid #f5f5f5;
            .tab-item
              float: left;
              height: 25px
              width: 50%
              line-height: 25px
              text-align: center
              color: #666
              font-size: 18px
              cursor: pointer
              &.active
                color: #ff6700
          .log-mid-wrapper
            margin-top: 40px
            .row
              margin-bottom: 40px
              width: 326px
              height: 60px
              box-sizing border-box
              border-radius: 4px
              position: relative
              background #ffffff
              .input-phone
                width: 326px
                height: 60px
                line-height: 60px
                padding-left: 20px
                font-size: 16px
                color: #333
                border-radius: 4px
                background #ffffff
                border: 1px solid #ccc
                box-sizing: border-box
                &:focus
                  border: 1px solid #ff6700
                &::webkit-input-placeholder
                  color: #ccc
              .send, .time
                position: absolute
                right: 0
                top: 15px
                display: inline-block
                height: 28px
                line-height: 28px
                width: 120px
                font-size: 16px
                text-align: center
                color: #ccc;
                border-left: 1px solid #cccccc
              .send
                cursor: pointer
            .log-btn
              height: 60px
              line-height: 60px
              width: 326px
              text-align: center
              color: #fff
              font-size: 18px
              border-radius: 4px
              background: #ff6700

          .hint
            margin-top: 18px
            height: 20px;
            line-height: 20px;
            text-align: center
            font-size: 14px;
            color: #ccc
            a
              color: #ff6700;
              margin-left: 4px
</style>



// WEBPACK FOOTER //
// src/page/log/Log.vue